import { executeReport, REPORT_TYPES } from '../../../../../../../../../../logic/utils/reportRequest';
import seachByKey from '../../../../../utils/seachByKey';

export default async function SqlQuery(startTime, endTime) {
  const barData = {
    count_close: [],
    count_neyavka: [],
    count_del: [],
    count_crate: [],
  };

  const daysInWeek = [
    {
      days: 'mon', daycount: 0, count_close: 0, count_neyavka: 0, count_del: 0, count_crate: 0,
    },
    {
      days: 'tue', daycount: 0, count_close: 0, count_neyavka: 0, count_del: 0, count_crate: 0,
    },
    {
      days: 'wed', daycount: 0, count_close: 0, count_neyavka: 0, count_del: 0, count_crate: 0,
    },
    {
      days: 'thu', daycount: 0, count_close: 0, count_neyavka: 0, count_del: 0, count_crate: 0,
    },
    {
      days: 'fri', daycount: 0, count_close: 0, count_neyavka: 0, count_del: 0, count_crate: 0,
    },
    {
      days: 'sat', daycount: 0, count_close: 0, count_neyavka: 0, count_del: 0, count_crate: 0,
    },
    {
      days: 'sun', daycount: 0, count_close: 0, count_neyavka: 0, count_del: 0, count_crate: 0,
    },
  ];

  // Получаем данные через новый API
  const result = await executeReport(REPORT_TYPES.GENERAL_BAR_CHART, { startTime, endTime });
  const myData = result.dataObjects;

  // Заполняем barData для каждого дня недели
  daysInWeek.forEach((el) => {
    const curDay = seachByKey(myData, 'days', el.days);
    const realDay = (curDay) || el;
    Object.keys(realDay).forEach((key) => {
      if (Object.prototype.hasOwnProperty.call(barData, key)) {
        barData[key].push(Number(realDay[key]));
      }
    });
  });

  return barData;
}
